import styled from 'styled-components';
import { Layout } from 'antd';
import exp from 'constants';
const { Content } = Layout;

export const StyledMainLayout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderLine = styled.div`
  height: 100%;
  margin-left: 0px;
  margin-right: 0px;
  width: 1px;
  background-color: rgba(0,0,0,0.5);
  border: 0;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
`;

export const StyledLayout = styled(Layout)`
  display: flex;
  flex-wrap: nowrap;
  padding-left: 0;
  flex-direction: row;
  flex: 1;
  min-height: 100%;
  background-color: #ffffff;
`;

export const StyledContent = styled(Content)`
  padding: 15px;
  min-height: calc(100vh - 58px);
  margin-left: 205px;
  ${({ theme }) =>
      theme.media.monitor(
      `
       margin-left: 255px;
      `,
    )}
`;
